<template>
  <div class="ui-page">
    <div class="header">
      <slot name="header"></slot>
    </div>
    <div class="container"
         ref="wrapper">
      <div class="scroll-wrapper">
        <slot>
        </slot>
        <div class="pullup-wrapper"
             v-if="pullUpLoad || isNoMoreData">
          <div class="before-trigger"
               v-if="!isPullUpLoad">
            <span>{{pullUpTxt}}</span>
          </div>
          <div class="after-trigger"
               v-else>
            <loading></loading>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
  name: 'nfPage',
  props: {
    /**
     * 1 滚动的时候会派发scroll事件，会截流。
     * 2 滚动的时候实时派发scroll事件，不会截流。
     * 3 除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
     */
    probeType: {
      type: Number,
      default: 1
    },
    /**
     * 点击列表是否派发click事件
     */
    click: {
      type: Boolean,
      default: true
    },
    /**
     * 是否开启横向滚动
     */
    scrollX: {
      type: Boolean,
      default: false
    },
    /**
     * 是否派发滚动事件
     */
    listenScroll: {
      type: Boolean,
      default: false
    },
    /**
     * 列表的数据
     */
    data: {
      type: Array,
      default: null
    },
    /**
     * 是否派发滚动到底部的事件，用于上拉加载
     */
    pullup: {
      type: Boolean,
      default: false
    },
    /**
     * 是否派发顶部下拉的事件，用于下拉刷新
     */
    pulldown: {
      type: Boolean,
      default: false
    },
    /**
     * 是否派发列表滚动开始的事件
     */
    beforeScroll: {
      type: Boolean,
      default: false
    },
    /**
     * 当数据更新后，刷新scroll的延时。
     */
    refreshDelay: {
      type: Number,
      default: 20
    },
    /**
     * 固定某个方向模拟滚动，另一个方向原生滚动
     * 可选值：'vertical'、'horizontal'
     */
    eventPassthrough: {
      type: String,
      default: ''
    },
    pullUpTxt: {
      type: String,
      default: '已显示全部内容'
    },
    // 是否已经没有更多
    isPullUpLoad: {
      type: Boolean,
      default: true
    },
    pullUpLoadOptions: {
      type: [Boolean, Object],
      default() {
        return {
          threshold: 10
        }
      }
    },
    // 是否显示底部的加载中或者没有更多提示文本
    isShowPullingUpMsg: {
      type: Boolean,
      default: true
    },
    // 显示没有更多数据
    isNoMoreData: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pullUpLoad: false
    }
  },
  methods: {
    _initScroll() {
      if (!this.$refs.wrapper) {
        return
      }
      // better-scroll的初始化
      this.scroll = new BScroll(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click,
        scrollX: this.scrollX,
        pullUpLoad: {
          threshold: 50
        },
        eventPassthrough: this.eventPassthrough
      })

      // 是否派发滚动事件
      if (this.listenScroll) {
        this.scroll.on('scroll', pos => {
          // 没有数据的时候不能触发
          if (
            pos.y < 0 &&
            pos.y <= this.scroll.maxScrollY + 50 &&
            !this.pullUpLoad
          ) {
            this.pullUpLoad = true
            this.$nextTick(() => {
              this.refresh()
            })
            this.$emit('scrollToEnd')
          }
          this.$emit('scroll', pos)
        })
      }

      // 是否派发滚动到底部事件，用于上拉加载
      if (this.pullup) {
        this.scroll.on('scrollEnd', () => {
          // 滚动到底部
          // if (this.scroll.y <= this.scroll.maxScrollY + 50) {
          //   this.pullUpLoad = true
          //   this.$nextTick(() => {
          //     this.refresh()
          //   })
          //   this.$emit('scrollToEnd')
          // }
        })
      }

      // 是否派发顶部下拉事件，用于下拉刷新
      if (this.pulldown) {
        this.scroll.on('touchend', pos => {
          // 下拉动作
          if (pos.y > 50) {
            this.$emit('pulldown')
          }
        })
      }

      // 是否派发列表滚动开始的事件
      if (this.beforeScroll) {
        this.scroll.on('beforeScrollStart', () => {
          this.$emit('beforeScroll')
        })
      }
    },
    disable() {
      // 代理better-scroll的disable方法
      this.scroll && this.scroll.disable()
    },
    enable() {
      // 代理better-scroll的enable方法
      this.scroll && this.scroll.enable()
    },
    refresh() {
      // 代理better-scroll的refresh方法
      this.scroll && this.scroll.refresh()
    },
    scrollTo() {
      // 代理better-scroll的scrollTo方法
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
    },
    scrollToElement() {
      // 代理better-scroll的scrollToElement方法
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
    },
    // 结束上拉加载
    finishPullUpLoad() {
      this.pullUpLoad = false
      this.$nextTick(() => {
        this.refresh()
      })
    },
    openPullUp() {
      this.scroll && this.scroll.openPullUp()
    }
  },
  watch: {
    // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
    data() {
      setTimeout(() => {
        this.refresh()
      }, this.refreshDelay)
    }
  },
  mounted() {
    // 保证在DOM渲染完毕后初始化better-scroll
    setTimeout(() => {
      this._initScroll()
    }, 20)
  }
}
</script>

<style scoped>
.ui-page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.header,
.footer {
  flex: none;
}
.container {
  position: relative;
  flex: 1;
  overflow: hidden;
}
.container .scroll-wrapper {
  height: auto;
  width: 100%;
}
.pullup-wrapper {
  width: 100%;
  height: 0.8rem;
  background: #ffffff;
}
.before-trigger,
.after-trigger {
  width: 100%;
  height: 0.8rem;
  color: #999999;
  font-size: 0.26rem;
  text-align: center;
  line-height: 0.8rem;
}
</style>


